import { render, staticRenderFns } from "./CategoryDefinitionForm.vue?vue&type=template&id=45396e54&scoped=true&"
import script from "./CategoryDefinitionForm.vue?vue&type=script&lang=js&"
export * from "./CategoryDefinitionForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDefinitionForm.vue?vue&type=style&index=0&id=45396e54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45396e54",
  null
  
)

export default component.exports